import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RadioButtonComponent, RadioGroupDirective } from './components/radio-button/radio-button.component';

@NgModule({
  declarations: [RadioButtonComponent, RadioGroupDirective],
  imports: [CommonModule, ReactiveFormsModule],
  exports: [RadioButtonComponent, RadioGroupDirective],
})
export class RadioModule {}
